import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  TableWrapper: {
    position: 'relative'
  },
  ApplyFilterWrapper:{
    marginTop: theme.spacing(4),
    textAlign: 'right'
  },
  ActivateButton:{
    padding: theme.spacing(0)
  },
  FilterChip: {
    display: 'flex',
    '& span': {
      marginLeft: theme.spacing(1)
    }
  }
}))
